// extracted by mini-css-extract-plugin
export default {"loading-placeholder":"styles_loading-placeholder__OY1-Z"};